import React from 'react';
import propTypes from 'prop-types';

export function UiEmptyStateForSars({ title, hideButton }) {
  return (
    <div className="ui-empty-state has-text-centered">
      {!hideButton && (
        <p className="subtitle has-text-grey is-6 is-spaced">
          Ready to Get Started?
        </p>
      )}
      <p className="title has-text-primary is-4">
        {!hideButton ? `Upload Your First ${title}!` : 'No items available.'}
      </p>
    </div>
  );
}

UiEmptyStateForSars.defaultProps = {
  hideButton: false,
};

UiEmptyStateForSars.propTypes = {
  title: propTypes.string.isRequired,
  hideButton: propTypes.bool,
};
